import { select } from '../utility/dom';
export var Event;
(function (Event) {
    Event["BEFORE_OPEN"] = "onBeforeOpen";
    Event["AFTER_OPEN"] = "onOpen";
    Event["BEFORE_CLOSE"] = "onBeforeClose";
    Event["AFTER_CLOSE"] = "onClose";
})(Event || (Event = {}));
;
export default class OverlayPanel extends EventTarget {
    constructor(element, config) {
        super();
        this._open = false;
        this._config = Object.assign({}, {
            CLOSE_HANDLER: '.close-btn',
            ACTIVE_BODY_CLASSNAME: 'overlay-panel-shown',
            ACTIVE_CLASSNAME: 'shown',
        }, config);
        if (typeof (element) === 'string') {
            this._element = select(element).firstOrFail();
        }
        else {
            this._element = element;
        }
        this._attachEvents();
    }
    get element() {
        return this._element;
    }
    get isOpen() {
        return this._open;
    }
    open() {
        this._dispatchEvent(Event.BEFORE_OPEN);
        this._element.classList.add(this._config.ACTIVE_CLASSNAME);
        document.body.classList.add(this._config.ACTIVE_BODY_CLASSNAME);
        this._open = true;
        this._dispatchEvent(Event.AFTER_OPEN);
    }
    close() {
        this._dispatchEvent(Event.BEFORE_CLOSE);
        this._element.classList.remove(this._config.ACTIVE_CLASSNAME);
        document.body.classList.remove(this._config.ACTIVE_BODY_CLASSNAME);
        this._open = false;
        this._dispatchEvent(Event.AFTER_CLOSE);
    }
    _dispatchEvent(eventType) {
        const event = new CustomEvent(eventType, { detail: { instance: this } });
        this.dispatchEvent(event);
    }
    _attachEvents() {
        const _this = this;
        const openBtn = select(this._config.OPEN_HANDLER).firstOrFail();
        const closeBtn = select(this._config.CLOSE_HANDLER, this._element).firstOrFail();
        openBtn.addEventListener('click', () => {
            _this.open();
        });
        closeBtn.addEventListener('click', () => {
            _this.close();
        });
        document.addEventListener('keydown', event => {
            if (event.key === 'Escape' && this._open) {
                _this.close();
            }
        });
    }
}
